import type { GameState } from '../../core/types';
import type { CommandHandler } from '../App';

interface EndScreenProps {
  state: GameState;
  onCommand: CommandHandler;
}

function RunSummary({ state }: { state: GameState }) {
  const run = state.run;
  if (!run) return null;

  return (
    <dl className="end-summary">
      <div><dt>Seed</dt><dd>{state.seed}</dd></div>
      <div><dt>Pressure</dt><dd>{run.difficulty === 'deepening' ? 'Deepening' : 'Standard'}</dd></div>
      <div><dt>Fights cleared</dt><dd>{run.combatsWon}</dd></div>
      <div><dt>Bosses defeated</dt><dd>{run.bossesDefeated}/3</dd></div>
      <div><dt>Depth reached</dt><dd>{run.node}/15</dd></div>
      <div><dt>Iron carried</dt><dd>{run.iron}</dd></div>
      <div><dt>Final deck</dt><dd>{run.deck.length} cards</dd></div>
    </dl>
  );
}

export function DefeatScreen({ state, onCommand }: EndScreenProps) {
  return (
    <main id="main-content" className="end-screen end-screen--defeat">
      <section className="end-panel">
        <span className="end-emblem" aria-hidden="true"><i /><i /><i /></span>
        <p className="kicker">Expedition ended</p>
        <h1>The line falls silent</h1>
        <p className="end-panel__lede">
          Your expedition is lost. The isolation gates remain closed. Somewhere beyond the gantries, Dimiti continues his ancient balancing act.
        </p>
        <RunSummary state={state} />
        <button className="primary-action" type="button" onClick={() => onCommand({ type: 'abandon_run' })}>
          Return to camp
        </button>
      </section>
    </main>
  );
}

export function VictoryScreen({ state, onCommand }: EndScreenProps) {
  return (
    <main id="main-content" className="end-screen end-screen--victory">
      <section className="end-panel">
        <span className="end-emblem" aria-hidden="true"><i /><i /><i /></span>
        <p className="kicker">Expedition victorious</p>
        <h1>The intake is sealed</h1>
        <p className="end-panel__lede">
          The Counterfeit Heart stops. Sealed cylinders settle into their cradles, and the surviving crew crosses the evacuation rail.
          Dimiti remains immense on the horizon. You have stopped a machine, not a god.
          Deepening pressure is available for future expeditions.
        </p>
        <RunSummary state={state} />
        <button className="primary-action" type="button" onClick={() => onCommand({ type: 'abandon_run' })}>
          Begin another expedition
        </button>
      </section>
    </main>
  );
}
